import { dispatch } from '~/state';
import { createCollectionClient } from '~/state/lib';

const AgentsClient = {
  agents: createCollectionClient(dispatch, 'agents'),
};

export default AgentsClient;
